import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'
import { LOCALES } from '@/constants/options'
import { SupportedLanguage } from '@/enum'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: LOCALES,
  // Used when no locale matches
  defaultLocale: SupportedLanguage.English,
  localePrefix: 'as-needed',
  localeDetection: true, // Automatically detect which locale the user prefers based on the Accept-Language header sent in the page request.
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
